// Bouton "Filtrer" pour ouvrir les filtres en version mobile
const searchToggler = document.querySelector('.search-toggler');
const searchWrapper = document.getElementById('search-form-wrapper');

if (typeof(searchToggler) != 'undefined' && searchToggler != null) {
  searchToggler.addEventListener('click', () => {
    const isActive = searchToggler.classList.contains('active');

    // Ouvrir celui cliqué
    if (!isActive) {
      searchToggler.classList.add('active');
      searchToggler.setAttribute('aria-expanded', 'true');
      searchWrapper.classList.add('search--opened')
    } else {
      searchToggler.classList.remove('active');
      searchToggler.setAttribute('aria-expanded', 'false');
      searchWrapper.classList.remove('search--opened')
    }
  });
}